package com.essntl.features.profile.data.supabase

import com.essntl.features.profile.domain.model.ProfileModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProfileDto(
    val id: String,
    @SerialName("first_name")
    val firstName: String?,
    @SerialName("last_name")
    val lastName: String?,
    val email: String?,
    @SerialName("phone_number")
    val phoneNumber: String?,
    @SerialName("app_version")
    val appVersion: String?,
    val role: String?,
) {
    fun toModel() =
        ProfileModel.empty.copy(
            id = id,
            firstName = firstName,
            lastName = lastName,
            email = email,
            phoneNumber = phoneNumber,
            appVersion = appVersion,
            role = when (role) {
                "USER" -> ProfileModel.Role.User
                "ADMIN" -> ProfileModel.Role.Admin
                "SUPERVISOR" -> ProfileModel.Role.Supervisor
                "OWNER" -> ProfileModel.Role.Owner
                else -> null
            },
        )
}